import type { Params } from 'react-router';
import { generatePath } from 'react-router';
import { useNavigate } from 'react-router-dom';

export const useMoveToPath = () => {
  const navigate = useNavigate();
  const moveToPath = (routePath: string, params: Params) => {
    const urlGenerate = () => generatePath(routePath, params);
    navigate(urlGenerate());
  };
  return { moveToPath };
};
